import { forwardRef } from "react";
import {
  CancelButton,
  ClearButton,
  DangerButton,
  DangerOutlineButton,
  LinkButton,
  PrimaryButton,
  RevertButton,
  SecondaryButton,
  Spinner,
  WarningButton,
} from "./styles";
import { ButtonProps } from "./types";

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      type,
      size = "medium",
      children,
      isFullWidth = false,
      buttonType = "button",
      isLoading = false,
      disabled = false,
      tone = "primary",
      underline = false,
      ...nativeProps
    },
    ref,
  ) => {
    const sharedProps = {
      ...nativeProps,
      ref,
      type: buttonType,
      size,
      $isFullWidth: isFullWidth,
      disabled: disabled || isLoading,
      "aria-busy": isLoading || undefined,
    };

    const content = (
      <>
        {isLoading && <Spinner $size={size} aria-hidden />}
        {children}
      </>
    );

    switch (type) {
      case "secondary":
        return <SecondaryButton {...sharedProps}>{content}</SecondaryButton>;
      case "cancel":
        return <CancelButton {...sharedProps}>{content}</CancelButton>;
      case "revert":
        return <RevertButton {...sharedProps}>{content}</RevertButton>;
      case "warning":
        return <WarningButton {...sharedProps}>{content}</WarningButton>;
      case "danger":
        return <DangerButton {...sharedProps}>{content}</DangerButton>;
      case "dangerOutline":
        return (
          <DangerOutlineButton {...sharedProps}>{content}</DangerOutlineButton>
        );
      case "clear":
        return <ClearButton {...sharedProps}>{content}</ClearButton>;
      case "link":
        return (
          <LinkButton {...sharedProps} $tone={tone} $underline={underline}>
            {content}
          </LinkButton>
        );
      default:
        return <PrimaryButton {...sharedProps}>{content}</PrimaryButton>;
    }
  },
);

Button.displayName = "Button";

export default Button;
